export const birds = [
   "African Gray Parrot",
   "African Pied Hornbill",
   "Alexandrine",
   "Alexandrine     Gang-Gang",
   "Amazon",
   "Ameraucana",
   "American Avocet",
   "American Black Turkey",
   "American Blue (Slate) Turkey",
    "American Bronze Turkey",
   "American Cracker Horse",
   "American Crow",
   "American Kestrel",
   "Araucana Chicken",
   "Australorp",
   "Bald Eagle",
   "Barn Owl",
   "Barred Owl",
   "Beltsville Small White",
   "Bird",
   "Black",
   "Blackbilled Amazon",
       "Blue-and-Gold Macaw",
   "Blue Cheeked Amazon",
  "Blue Cochin",
   "Blue Crown Conure",
   "Blue Fronted Amazon",
  "Blue Fronted Amazon Parrot",
   "Bourbon red turkey",
   "Bourke’s Parakeet",
   "Broad-winged hawk",
    "Budgerigar",
   "Buff Orpington",
   "Burrowing owl",
  "Caique",
   "Cambridge bronze turkey",
   "Canary",
   "Canaries",
   "Cockatiel",
   "Cockatoo",
   "Conures",
   "Dove",
   "Finch",
   "Green-Winged Macaw",
   "Hyacinth Macaw",
   "Lovebird",
   "Monk Parakeet",
   "Not Listed",
   "Other",
   "Parakeet",
   "Parrotlet",
   "Penguin",
   "Pionus Parrot",
   "Scarlet Macaw",
   "I don't know",
   "Sebastopol Goose",
   "Senegal Parrot",
   "Catalina macaw",
   "Cherry head conure",
   "Chicken",
   "Cockatiel",
   "Cooper's Hawk",
   "Cornish Game Hen",
   "Corrella",
   "Cuban amazon",
   "Czech turkey",
   "Delaware",
   "Deutsche Pute Turkey",
   "Diademed Amazon",
    "Dindon de Ronquières Turkey",
   "Dindon de Sologne Turkey",
    "Dindon du Bourbonnais Turkey",
    "Dindon du Gers Turkey",
   "Dindon Rouge Des Ardennes Turkey",
   "Dove",
   "Duck",
   "Eclectus",
   "Emu",
    "English Turkey",
   "Falcon",
    "Festive amazon",
    "Finch",
   "Flamingo",
   "French Turkey",
    "Galah",
    "Galah Corella",
   "Gang Gang",
   "Goffin Cockatoo",
   "Golden Eagle",
   "Goose",
   "Goshawk",
    "Great Blue Heron",
   "Great Horned Owl",
   "Great White Egret",
    "Green Cheek Conure",
   "Green-cheeked Parakeet",
    "Gyrfalcon",
   "Harlan",
 "Harris's Hawk",
   "Hawk Headed Parrot",
    "Hispaniolan amazon",
   "Imperial amazon",
   "Indian Ring Neck Parrot",
    "Isa Brown Chicken",
   "Jenday Conure",
    "Jersey Giant",
   "Kawall's amazon",
   "Large Cockatoo",
   "Large Conure",
   "Large Parakeet",
    "Leghorn",
   "Lesser Jardine Parrot",
 "Lilac-crowned amazon",
   "Lilacine amazon",
   "Little Lorikeet",
   "Long Billed Corella",
   "Long-Eared Owl",
  "Lory/Lorikeet",
    "Love Bird",
    "Macaw",
   "Magpie",
   "Major Mitchell Cockatoo",
   "Mealy Amazon",
    "Merlin",
   "Mexican Spotted Owl",
    "Meyers Parrot",
   "Mini-Macaw",
   "Mixed Breed",
   "Moluccan Cockatoo",
   "Moustached Parrot",
   "Musk Lorikeet",
   "Naretha Bluebonnet",
   "Narragansett",
   "Narragansett Turkey",
   "Norfolk Black Turkey",
    "Northern Hawk Owl",
   "Northern Saw-whet Owl",
    "Orange-winged amazon",
   "Ostrich",
    "Pacific Parrotlet",
   "Panama amazon",
    "Parakeet",
   "Parrot",
   "Parrotlet",
   "Patagonian",
  "Peacock",
   "Pelican",
    "Peregrine Falcon",
   "Pheasant",
   "Pigeon",
   "Pionus Parrot",
    "Plum Headed Parrot",
   "Plymouth Rock",
    "Poicephalus",
    "Polish Chicken",
  "Puerto Rican Amazon",
   "Purple Crown Lorikeet",
   "Quail",
   "Quaker Parakeet",
   "Quaker Parrot",
   "Rainbow Lorikeet",
   "Red Collar Lorikeet",
   "Red Tailed Black Cockatoo",
    "Red-browed Amazon",
    "Red-crowned amazon",
   "Red-lored Amazon",
   "Red-necked Amazon",
   "Red-spectacled Amazon",
    "Red-tailed amazon",
    "Red-tailed Hawk",
   "Rhode Island Red",
   "Ring-necked Dove",
   "Roadrunner",
   "Roman Tufted Goose",
   "Rose-breasted Cockatoo",
    "Rosella",
    "Rosy-Faced Lovebird",
   "Royal Palm",
   "Royal Palm Turkey",
    "Saint Lucia Amazon",
   "Saint Vincent Amazon",
   "Sandhill Crane",
   "Scaly Breasted Lorikeet",
   "Scaly-naped Amazon",
   "Sebastopol Goose",
   "Senegal Parrot",
   "Severe Macaw",
   "Slate",
   "Sled Dog",
   "Small Cockatoo",
   "Small Conure",
   "Small Parakeet",
   "Snowy Owl",
   "Standard Bronze",
   "Sulphur Crested Cockatoo",
   "Sun Conure",
   "Sussex Chicken",
 "Tacchino castano d\'Italia Turkey",
 "Tacchino nero d\'Italia Turkey",
   "Timneh Parrot",
   "Tolouse Goose",
   "Tres Marías Amazon",
   "Tucumán Amazon",
    "Umbrella Cockatoo",
    "Unknown",
   "Varied Lorikeet",
   "Vinaceous-Breasted Amazon",
   "Welsummer",
   "Western Screech Owl",
    "White Holland",
   "White Holland Turkey",
   "White Tailed Black Cockatoo",
  "White-fronted Amazon",
    "Wyandotte",
  "Yellow Tail Black Cockatoo",
    "Yellow-billed Amazon",
   "Yellow-collared Mini Macaw",
   "Yellow-crowned Amazon",
   "Yellow-headed amazon",
   "Yellow-naped amazon",
   "Yellow-shouldered amazon",
   "Yucatan Amazon",
   "Eastern Screech Owl",
]
